<template>
	<div class="container2">
		<div class="main-img">
			<el-carousel :interval="5000" arrow="always" class="main-img-all">
				<el-carousel-item v-for="(item,index) in imgList" :key="index" class="main-img-lb">
					<el-image class="main-img1"
						:src="item.img"></el-image>
				</el-carousel-item>
			</el-carousel>
		</div>
		<!-- <div class="menu">
			<div class="menu1" v-for="(item,index) in currentPageItems" :key="index" :class="mouse_index==index?'item-sel':''" @mouseover="mouseOver(index)" @mouseout="mouseOut(index)">
				<div class="menu1-img">
					<el-image class="menu1-img1" :src="item.img" fit="cover"></el-image>
				</div>
				<div class="menu1-text">
					<div class="menu1-text1" :class="mouse_index==index?'item-text':''">{{item.name}}</div>
					<div class="menu1-text2">{{item.name1}}</div>
					<div class="menu1-text3">{{item.name2}}</div>
				</div>
			</div>
			
		</div> -->
	<!-- 	<div class="menu2">
			<button class="menu2-1" @click="goToPreviousPage" :disabled="currentPage === 1">上一页</button>  
			<div class="main4-2">{{ currentPage }} / {{ totalPages }}</div>
			<button class="menu2-2" @click="goToNextPage" :disabled="currentPage === totalPages">下一页</button>
		</div> -->
		
		
		<!-- <div class="main4">
			<div class="main4-1 mr-left" :class="currentPage === 1?'main4-4':''" @click="goToPreviousPage" :disabled="currentPage === 1">上一页</div>
			<div class="main4-2">{{ currentPage }} / {{ totalPages }}</div>
			<div class="main4-1 mr-right" :class="currentPage === totalPages?'main4-4':''" @click="goToNextPage" :disabled="currentPage === totalPages">下一页</div>
		</div> -->
		
		<div class="fotter">
			<div class="fotter1">
				<div class="fotter1-text">
					<span class="color-text3">能量工厂</span>
					<span>官网-深圳市乐园互联网科技有限公司</span>
				</div>
				<div class="fotter1-text2">
					<div class="fotter1-text2-1">
						<span>能量工厂-全球十大</span>
						<span class="color-text">共享充电线</span>
						<span>品牌之一，</span>
						<span class="color-text2">能量工厂3c认证</span>
					</div>
					<div class="fotter1-text2-2">
						<span class="fotter1-text2-2-left color-text3">共享充电线</span>
						<span>，共享充电宝加盟代理，</span>
						<span class="fotter1-text2-2-left color-text3">共享WiFi贴</span>
						<span>，酒店售货机厂家招商加盟</span>
					</div>
					<div class="fotter1-text2-3">
						<span>代理加盟咨询老板：刘总 </span>
						<span class="color-text3">15899889999</span>
						<span> 微信同号</span>
					</div>
					<div class="fotter1-text2-4">
						<span>公司总部：广东省深圳市宝安区新桥街道上星社区上星路万科星城星宸大厦第3栋6楼整层</span>
					</div>
				</div>
			</div>
			<div class="fotter2">
				<!-- <el-image src="../../assets/img/cable/guanfang.jpg"></el-image> -->
				<!-- <img src="../../assets/img/cable/guanfang.jpg"/> -->
				<img src="../../assets/img/product/erweima.png"/>
				<!-- <img src="../../assets/jiudianbao.jpg"/> -->
			</div>
		</div>
    </div>
</template>

<script>
	export default {
		data() {
			return {
				allData:[
					{
						id:1,
						name:'共享充电线',
						name1:'类型ï¼š共享充电线',
						name2:'品牌ï¼š能量工厂科技',
						img:require('../../assets/img/product/1.jpeg')
					},
					{
						id:2,
						name:'能量工厂密码式共享充电线',
						name1:'类型ï¼š共享充电线',
						name2:'品牌ï¼š能量工厂科技',
						img:require('../../assets/img/product/2.jpeg')
					},
					{
						id:3,
						name:'共享WiFi贴纸-共享WiFi精灵',
						name1:'类型ï¼š共享WiFi贴',
						name2:'品牌ï¼š能量工厂科技',
						img:require('../../assets/img/product/3.jpeg')
					},
					{
						id:4,
						name:'共享充电宝8口机柜',
						name1:'类型ï¼š共享充电宝租凭机',
						name2:'品牌ï¼š能量工厂科技',
						img:require('../../assets/img/product/4.jpeg')
					},
					{
						id:5,
						name:'能量工厂6口共享充电宝机柜',
						name1:'类型ï¼š共享充电宝',
						name2:'品牌ï¼š能量工厂科技',
						img:require('../../assets/img/product/5.jpeg')
					},
					{
						id:6,
						name:'共享充电宝16口机柜',
						name1:'类型ï¼š共享充电宝租凭机',
						name2:'品牌ï¼š能量工厂科技',
						img:require('../../assets/img/product/7.jpg')
					},
					{
						id:7,
						name:'共享充电宝',
						name1:'类型ï¼š共享充电宝租凭机',
						name2:'品牌ï¼š倍能量工厂科技',
						img:require('../../assets/img/product/6.jpeg')
					},
					{
						id:8,
						name:'能量工厂快充充电宝',
						name1:'类型ï¼š快充充电宝',
						name2:'品牌ï¼š能量工厂科技',
						img:require('../../assets/img/product/8.jpeg')
					},
					{
						id:9,
						name:'32口共享充电宝广告机',
						name1:'类型ï¼š共享充电宝广告机',
						name2:'品牌ï¼š能量工厂科技',
						img:require('../../assets/img/product/9.jpeg')
					},
					{
						id:10,
						name:'能量工厂充电宝-新款彩虹宝',
						name1:'类型ï¼š充电宝',
						name2:'品牌ï¼š能量工厂科技',
						img:require('../../assets/img/product/8.jpeg')
					},
					{
						id:11,
						name:'共享充电宝8口机柜',
						name1:'类型ï¼š共享充电宝租凭机',
						name2:'品牌ï¼š能量工厂科技',
						img:require('../../assets/img/product/9.jpeg')
					},
					{
						id:12,
						name:'能量工厂4口共享充电宝机柜',
						name1:'类型ï¼š共享充电宝',
						name2:'品牌ï¼š能量工厂科技',
						img:require('../../assets/img/product/10.jpeg')
					},
					{
						id:13,
						name:'能量工厂12口共享充电宝机柜',
						name1:'类型ï¼š共享充电宝',
						name2:'品牌：能量工厂科技',
						img:require('../../assets/img/product/11.jpeg')
					},
					{
						id:14,
						name:'21口带广告屏得共享充电宝立式机柜',
						name1:'类型ï¼š立式共享充电宝机柜',
						name2:'品牌ï¼š能量工厂科技',
						img:require('../../assets/img/product/13.jpg')
					},
					{
						id:15,
						name:'酒店共享充电线',
						name1:'类型ï¼š共享充电线',
						name2:'品牌ï¼š能量工厂科技',
						img:require('../../assets/img/product/1.jpeg')
					},
					{
						id:16,
						name:'能量工厂手机扫码充电器-酒店共享充电器',
						name1:'类型ï¼š共享充电线',
						name2:'品牌ï¼š能量工厂科技',
						img:require('../../assets/img/product/2.jpeg')
					},
				],
				mouse_index:null,
				// currentPage: 1, // 当前页码  
				// pageSize: 12 ,// 每页显示的数量  
				
				currentPage: 1, // 当前页码
				totalPages: 0, // 总页数  
				totalItems: 0, // 总项目数  
				itemsPerPage:4,
				// {
				// 	id:2,
				// 	img:require('../../assets/img/main/8.jpeg')
				// },
				imgList:[
				
					
					{
						id:3,
						img:require('../../assets/img/main/9.jpeg')
					},
				],
			}
		},
		// computed:{
		// 	currentData() {  
		// 	      const start = (this.currentPage - 1) * this.pageSize;  
		// 	      const end = start + this.pageSize;  
		// 		  console.log('start',start)
		// 		  console.log('end',end)
		// 	      return this.list.slice(start, end);  
		// 	    },  
		// 	    pageCount() {  
		// 			console.log('11',Math.ceil(this.list.length / this.pageSize))
		// 	      return Math.ceil(this.list.length / this.pageSize);  
		// 	}  
		// }, 
		computed: {
		     currentPageItems() {  
		         const startIndex = (this.currentPage - 1) * this.itemsPerPage;  
		         const endIndex = startIndex + this.itemsPerPage;  
		         return this.allData.slice(startIndex, endIndex);  
		       },  
		  },
		created() {
			this.totalItems =this.allData.length;
					this.totalPages =Math.ceil(this.totalItems / this.itemsPerPage);
		},
		methods: {
			// 上下页
			goToPreviousPage() {
			    if (this.currentPage > 1) {  
			      this.currentPage--;  
			    }  
			  },  
			  goToNextPage() {  
			    if (this.currentPage < this.totalPages) {  
			      this.currentPage++;  
			    }  
			  }, 
			
			mouseOver(index){
			    this.mouse_index = index;
			},
			mouseOut(index){
				this.mouse_index = null;
			},
			goToPage(page) {  
			      this.currentPage = page;  
			},  
			nextPage() {  
			    if (this.currentPage < this.pageCount) {  
			        this.currentPage++;  
			    }  
			},  
			prevPage() {  
			    if (this.currentPage > 1) {  
			        this.currentPage--;  
			    }  
			}
		}
	}
</script>

<style scoped>
	.container2 {
		background: #ffffff;
		padding-bottom: 20px;
	}
	.main-img-all {
		width: 100%;
	}
	
	.main-img-lb {
		/* height: 420px; */
	}
	
	.main-img1 {
		width: 100%;
		height: 440px;
	}
	
	::v-deep .el-carousel__container {
		min-height: 440px;
	}
	.menu{
		margin-top: 3%;
		display: flex;
		align-items: center;
		flex-wrap: wrap;
	}
	.menu1{
		width: 19%;
		margin-right: 1%;
		margin-left: 1%;
		margin-bottom:4%;
		padding: 2%;
	}
	.menu1-img1{
		width: 80%;
	}
	.menu1-text1{
		font-size: 16px;
		color: #333;
	}
	.menu1-text2{
		color: #666;
		font-size: 14px;
		margin-top: 4%;
	}
	.menu1-text3{
		color: #666;
		font-size: 14px;
		margin-top: 1%;
	}
	.item-sel{
		box-shadow: 0 0 5px 3px #f5f5f5;
	}
	.item-text{
		color: #5cb6ed;
	}
	.menu2{
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.menu2-2{
		margin-left: 5%;
	}
	button {
	  margin: 0;
	  padding: 0;
	  outline: none;
	  border-radius: 0;
	  background-color: transparent;
	  line-height: inherit;
	  width: max-content;
	  border: none
	}
	button:after {
	  border: none;
	}
	
	.fotter{
		margin-top: 5%;
		padding-left: 12%;
		padding-right: 12%;
		display: flex;
	}
	.fotter1{
		width: 50%;
		text-align: left;
		line-height: 30px;
	}
	.fotter2{
		width: 50%;
	}
	.fotter2 img{
		width: 50%;
	}
	.fotter1-text{
		font-size: 26px;
		color: rgb(51, 51, 51);
	}
	.fotter1-text2{
		margin-top: 3%;
		line-height: 2.8;
	}
	.fotter1-text2-4{
		margin-top: 3%;
	}
	
	.color-text {
		color: rgb(30, 80, 174);
	}
	.color-text2 {
		color: rgb(230, 74, 25);
	}
	.color-text3{
		color: rgb(73, 110, 232);
	}
	
	.main4{
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.main4-1{
		width: 50px;
		/* border: 1px solid #f23030; */
		border-radius: 0.1rem;
		overflow: visible;
		background-size: 100%;
		font-size: 14px;
		padding: 10px;
		text-align: center;
		cursor: pointer;
		
	}
	.mr-left{
		margin-left: 10px;
		
	}
	.mr-right{
		margin-right: 10px;
	}
	.main5{
		margin-top: 10px;
		text-align: center;
	}
	.main5-text{
		color: rgb(153, 153, 153);
		font-size: 14px;
		line-height: 26px;
	}
	.main4-2{
		margin-left: 5%;
		margin-right: 5%;
	}
	.main4-4{
		/* color: #f5f5f5; */
		color: #ccc!important;
	}
</style>